import React from 'react';
import moment from 'moment';
import Calendar from "../../../../picture/calendar.svg";
import Place from "../../../../picture/place.svg";
import { ReactComponent as Arrow } from '../../../../picture/arrow.svg'
import i18n from 'i18next';
import formattedAmount from '../../seller/components/utils';
import { useTranslation } from 'react-i18next';
import { classnames } from '../../../../utils/classnames';
import { parsedHTML } from './utils';
import './style/eventCard.css';

// TODO - componenet not ready for V1
function EventStatus({event, unavailable}) {
    const { t } = useTranslation();
    const status = React.useMemo(() => {
        if (unavailable) {
            return {color: 'gray', text: t('widget.resale.event.status.unavailable') }
        }
        return {color: 'green', text: t('widget.resale.event.status.available') }
    }, [event]);

    return (
        <div className='wz-event-status-container'>
            <div className={classnames('wz-event-status', status.color)}>{status.text}</div>
        </div>
    )
}

function EventCardLine({icon, text}) {
    return (
        <div className='wz-event-card-line-content'>
            <div className='wz-event-line-icon-container'>
                <img className='wz-event-line-icon' alt='' src={icon}/>
            </div>
            <div className='wz-event-line-text'>{text}</div>
        </div>
    )
}

function formatedDate(event) {
    const locale = i18n.language;

    const formatDateTime = React.useCallback((dateString, timezone, locale) => {
        if (!dateString) {
            return null;
        }
        let tzDate = moment.utc(dateString);
        const formatter_date = new Intl.DateTimeFormat(locale, { dateStyle: 'short', timeStyle: 'short', timeZone: timezone });
        return formatter_date.format(tzDate);
    },[])

    if (event.end_date) {
        return formatDateTime(event.start_date, event?.timezone || 'Europe/Paris', locale) + ' - ' + formatDateTime(event.end_date, event?.timezone || 'Europe/Paris', locale)
    } else {
        return formatDateTime(event.start_date, event?.timezone || 'Europe/Paris', locale)
    }
}

export default function EventCard({event, unavailable}) {

    const { t } = useTranslation();
    const [showMore, setShowMore] = React.useState(false);
    const toggleShowMore = React.useCallback(() => setShowMore(showMore => !showMore), []);

    return (
        <div className='wz-event-card'>
            <div className='wz-event-card-container'>
                { event.picture &&
                    <div className='wz-event-image'>
                        <img alt='' src={event.picture}/>
                    </div>
                }
                <div className='wz-event-infos'>
                    <EventStatus event={event} unavailable={unavailable}/>
                    <div className='wz-event-title'>{event.name}</div>
                    {event.min_price && <div className='wz-event-price'>{t('widget.resale.event.from')} {formattedAmount(event.min_price, event.currency)}</div>}
                    <EventCardLine icon={Calendar} text={formatedDate(event)}/>
                    <EventCardLine icon={Place} text={event.address}/>
                </div>
            </div>
            {event.description && (
                <div className='wz-event-read-more'>
                <div className='wz-read-more-container' onClick={toggleShowMore}>
                    <div className='wz-read-more'>{showMore ? t('widget.resale.event.show-less') : t('widget.resale.event.show-more')}</div>
                    <Arrow className={`wz-arrow-icon ${showMore ? 'wz-arrow-icon-down' : 'wz-arrow-icon-up'}`}/>
                </div>
            </div>
            )}
            <div className={showMore && 'wz-event-description'}>
                {showMore && parsedHTML(event.description)}
            </div>
        </div>
    )
}